/**
 * KindergartenTitleBlock.jsx
 * ════════════════════════════════════════════════════════════════
 * Варіант B: фото впритул зліва до заголовка (edge-to-edge, той
 * самий підхід що і в InvitationSection/картках команди).
 *
 * ВАЖЛИВО: обгортає ТІЛЬКИ заголовок+бейджі (коротка обмежена
 * висота), НЕ таби/контент — інакше фото розтягнулось би на всю
 * висоту сторінки при довгому контенті вкладки.
 *
 * Якщо обкладинки немає — рендериться так само, як раніше
 * (h1 + badges, без картки і фото).
 *
 * ВИКОРИСТАННЯ (замінює перші два елементи .kindergarten-header):
 *
 *   <KindergartenTitleBlock kindergartenData={kindergartenData}>
 *     <KindergartenBadge kindergartenData={kindergartenData}/>
 *   </KindergartenTitleBlock>
 *
 *   <div className="kindergarten-header">
 *     <KindergartenMainInfo kindergartenData={kindergartenData}/>
 *   </div>
 * ════════════════════════════════════════════════════════════════
 */

import React from 'react';
import { constr_uri } from '../../../services/apiClient';
import './KindergartenTitleBlock.css';

// Скоригуй шлях до constr_uri під структуру проекту

const KindergartenTitleBlock = ({ kindergartenData, children }) => {
  const title = [kindergartenData.number, kindergartenData.name].filter(Boolean).join(' ');

  // Для вузької смуги (~220px) достатньо стисненої версії —
  // та сама coverThumbFileId що і в картках на сторінці пошуку
  const coverFileForBlock = kindergartenData.coverThumbFileId || kindergartenData.coverFileId;
  const coverSrc = kindergartenData.coverDocId && coverFileForBlock
    ? constr_uri('docfile?doc_id=' + kindergartenData.coverDocId + '&file_id=' + coverFileForBlock)
    : null;

  // Без обкладинки — той самий вигляд що і раніше, без картки
  if (!coverSrc) {
    return (
      <div className="kindergarten-header">
        <h1 className="kindergarten-title">{title}</h1>
        {children}
      </div>
    );
  }

  return (
    <div className="kg-title-card">
      <div className="kg-title-photo">
        <img src={coverSrc} alt="" />
      </div>
      <div className="kg-title-text">
        <h1 className="kindergarten-title kg-title-card-h1">{title}</h1>
        {children}
      </div>
    </div>
  );
};

export default KindergartenTitleBlock;